import HistoricList from "@/components/Shared/HistoricList.vue"
import {showSuccessSnackBar} from "@/utils/SnackBartHelper";
import Rules from "@/utils/Rules";
const newHistorics = () => {
    return {
        historics: [],
    }
}

export default {
    name: "HistoricTab",
    
    components: {
        HistoricList,
    },
    
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        idProject: {
            type: String,
            required: true,
        }
    },
    
    data: () => ({
        revision: {status: null},
        is_loading: false,
        diagnostic: {},
        items: newHistorics(),
    }),

    computed: {
        rulesRequired() {
            return Rules.required()
        },
    },

    methods: {
        emitDiagnostic() {
            this.$emit('param:update', this.diagnostic)
        },
        emitValidate(status) {
            this.$emit('validate', status)
        },
        async addHistoric(historic, index) {
            if (index < 0) {
                historic.id_project = this.idProject;
                // Remover campos temporários antes de adicionar à lista
                delete historic.file_photo_account;
                delete historic._shouldDeleteFile;
                this.diagnostic.historics.push(historic)
                showSuccessSnackBar("Histórico salvo com sucesso!")
            } else {
                // Remover campos temporários antes de atualizar
                delete historic.file_photo_account;
                delete historic._shouldDeleteFile;
                Object.keys(this.diagnostic.historics[index]).forEach(
                    (key) => {
                        this.$set(this.diagnostic.historics[index], key, historic[key])
                    })
                showSuccessSnackBar("Histórico atualizado com sucesso!")
            }
            this.emitDiagnostic();
        },
        removeHistoric(index) {
            const item = this.diagnostic.historics[index];
            if (!this.diagnostic?.historicsToDelete) this.diagnostic.historicsToDelete = [];
            if (item.id_doc) this.diagnostic.historicsToDelete.push(item);
            this.diagnostic.historics = this.diagnostic.historics.filter((_, i) => i !== index)
            this.emitDiagnostic()
            showSuccessSnackBar("Histórico deletado com sucesso!")
        },
    },

    watch: {
        param: {
            immediate: true,
            handler: function (newValue) {
                if (newValue) {
                    this.diagnostic = newValue
                    if(!this.diagnostic.historics) this.diagnostic.historics = []
                }
            }
        },
    },

};